/* eslint-disable showpass-custom/no-hardcoded-colors */
/* eslint-disable showpass-custom/no-hardcoded-style-values */
import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function JCBLogo({ outline, ...props }: IconProps): JSX.Element {
  return outline ? (
    <JCBLogo.Outline {...props} />
  ) : (
    <JCBLogo.Solid {...props} />
  );
}

JCBLogo.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

JCBLogo.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <rect width="70" height="48" rx="4" fill="#303030" />
        <rect
          x="16.1484"
          y="17.9756"
          width="11.0872"
          height="12.0471"
          fill="white"
        />
        <rect
          x="29.2148"
          y="17.9756"
          width="11.0872"
          height="12.0471"
          fill="white"
        />
        <rect
          x="42.332"
          y="17.9756"
          width="11.0736"
          height="12.0471"
          fill="white"
        />
        <path
          d="M44.6362 24.5745C45.6635 24.5969 46.6967 24.5292 47.72 24.6097C48.7562 24.803 49.006 26.3718 48.0853 26.8856C47.4572 27.224 46.711 27.0116 46.03 27.0713H44.6362V24.5745ZM48.314 21.7485C48.5422 22.5542 47.7656 23.2775 46.9897 23.1666H44.6362C44.6527 22.4068 44.6039 21.5822 44.6601 20.8624C45.6029 20.889 46.5544 20.8083 47.4917 20.9046C47.8945 21.0058 48.2315 21.3369 48.314 21.7485ZM53.9779 9.80084C54.0217 11.3394 53.9842 12.9594 53.9968 14.5292C53.9939 20.9115 54.003 27.2936 53.9918 33.6762C53.9505 36.0681 51.8307 38.1465 49.4553 38.1943C47.0777 38.2039 44.6996 38.1958 42.3216 38.1984V28.5497C44.9126 28.5364 47.5048 28.5769 50.0947 28.5295C51.2962 28.4541 52.6122 27.6613 52.6681 26.3392C52.8095 25.0113 51.5576 24.0929 50.369 23.9478C49.9121 23.9359 49.9255 23.8146 50.369 23.7617C51.5027 23.5167 52.3929 22.3433 52.0594 21.1683C51.7751 19.9324 50.4091 19.454 49.2729 19.4564C46.9562 19.4406 44.639 19.4542 42.3222 19.4496C42.3371 17.6483 42.291 15.8451 42.347 14.0451C42.5306 11.6964 44.7038 9.75943 47.0457 9.80145C49.3568 9.8011 51.6674 9.80093 53.9779 9.80084Z"
          fill="#56B135"
        />
        <path
          d="M16.1417 14.2878C16.2009 11.8997 18.3297 9.83837 20.702 9.80346C23.0709 9.79617 25.4401 9.80241 27.809 9.8003C27.8025 17.7905 27.8218 25.7815 27.7993 33.7713C27.708 36.1304 25.6023 38.1524 23.2559 38.1942C20.8825 38.2028 18.5089 38.1954 16.1355 38.1978V28.2238C18.4409 28.7684 20.8584 29.0003 23.2103 28.639C24.6162 28.4128 26.1544 27.7224 26.6303 26.2639C26.9806 25.0163 26.7834 23.7033 26.8355 22.4228V19.4491H22.7653C22.747 21.4158 22.8028 23.386 22.7359 25.3504C22.6261 26.5578 21.4304 27.325 20.2916 27.284C18.8794 27.2989 16.0808 26.2605 16.0808 26.2605C16.0737 22.5756 16.1217 17.9605 16.1417 14.2878Z"
          fill="#086DB7"
        />
        <path
          d="M29.3261 20.649C29.1119 20.6944 29.2831 19.9192 29.2283 19.6251C29.2429 17.7657 29.1978 15.9043 29.2532 14.0462C29.4362 11.6875 31.6261 9.74574 33.9775 9.80095H40.9024C40.8959 17.7911 40.9151 25.7822 40.8926 33.7719C40.8013 36.131 38.6955 38.153 36.3489 38.1948C33.9755 38.2038 31.6018 38.1962 29.2282 38.1985V27.2707C30.8493 28.6007 33.0525 28.8078 35.0721 28.8114C36.5946 28.8109 38.1082 28.5761 39.5867 28.225V26.223C37.9205 27.0534 35.9618 27.5809 34.1147 27.1038C32.8262 26.7831 31.8909 25.5379 31.9117 24.2081C31.7624 22.8253 32.573 21.3654 33.9319 20.9543C35.6191 20.4261 37.4579 20.8301 39.0394 21.5168C39.3782 21.6942 39.7221 21.9143 39.5866 21.3479V19.7743C36.9417 19.145 34.1268 18.9134 31.4695 19.598C30.7003 19.815 29.951 20.1439 29.3261 20.649Z"
          fill="#E0063A"
        />
      </>
    ),
  });

  return <Icon viewBox="0 0 70 48" {...validateKeys(props)} />;
};
